export enum BuildingReturnTabEnum {
    WAREHOUSE_RETURN = 'รายการคลังอาคารและสิ่งปลูกสร้าง',
    RETURN = 'รายการส่งคืน',
    REQUISITION_EXTENSION = 'รายการการเบิก',
    DISPOSE = 'รายการจำหน่าย',
  }